const MESSAGES = {
  INVALID_REQUEST: {
    title: 'Could not open this code',
    message: 'The QR service rejected this request.',
  },
  TIMEOUT: {
    title: 'Taking too long',
    message: 'The QR service did not respond. Please try again.',
  },
  NETWORK_ERROR: {
    title: 'Connection problem',
    message: 'Check your internet connection and try again.',
  },
  UPSTREAM_ERROR: {
    title: 'Could not open this code',
    message: 'The QR service reported a problem. Please try again.',
  },
};

const DEFAULT = {
  title: 'Something went wrong',
  message: 'We could not open this QR code. Please try again.',
};

export default function ErrorPage({ code }) {
  const { title, message } = MESSAGES[code] ?? DEFAULT;

  return (
    <main className="panel">
      <div className="icon" aria-hidden="true">!</div>
      <h1>{title}</h1>
      <p className="muted">{message}</p>
      <button type="button" onClick={() => window.location.reload()}>
        Try again
      </button>
      <span className="code">{code}</span>
    </main>
  );
}
